import { render, staticRenderFns } from "./base-select.vue?vue&type=template&id=7751bf79"
import script from "./base-select.ts?vue&type=script&lang=ts&external"
export * from "./base-select.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports